import { useEffect, useState } from 'react';
import { compose, pick, propEq, propOr, reduce, isNotNil } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { QOfferMetadataQuery } from '../_graphql/queries/offers/QOfferMetadata';
import useFetchQuery from './useFetchQuery';

const useOfferMetadata = (offerId, bundleTag) => {
  const [metadata, setMetadata] = useState({});
  const {
    offerMetadata,
    isLoading,
    reFetch
  } = useFetchQuery({
    defaultData: {},
    args: {
      offerId,
      bundleTag
    },
    query: QOfferMetadataQuery,
    dataProp: 'offerMetadata'
  });

  useEffect(() => {
    if (!isLoading && propEq(true, 'ok', offerMetadata)) {
      const getValue = ({
        type,
        value
      }, options) => {
        if (isNotNil(type)) {
          switch (type) {
          case 'number':
            return Number(value);
          case 'boolean':
            return isNotNilOrEmpty(value) && JSON.parse(value);
          case 'JSON':
            return JSON.parse(value);
          default:
            return value;
          }
        }

        if (isNotNilOrEmpty(options)) {
          return propOr(false, 'value', options);
        }

        return '';
      };
      compose(
        setMetadata,
        reduce((acc, v) => {
          const {
            key,
            options,
            default: defaultValue
          } = pick(['key', 'options', 'default'], v);
          const value = getValue(defaultValue, options);

          return {
            ...acc,
            [key]: value
          };
        }, {}),
        propOr([], 'data')
      )(offerMetadata);
    }
  }, [isLoading, offerMetadata]);

  return {
    metadata: JSON.stringify(metadata, null, 2), isLoading, reFetch
  };
};

export default useOfferMetadata;
